// extracted by mini-css-extract-plugin
export default {"page":"index_page_mNTOx","bd":"index_bd_wMkbh","space40":"index_space40_JD7WJ"};